@if (open()) {
  <div class="eventq-dialog-popover" [class.eventq-dialog-popover--anchored]="isAnchored()">
    <button
      type="button"
      class="eventq-dialog-popover__backdrop"
      aria-label="Close dialog"
      (click)="onClose()"
    ></button>

    <div
      [class]="'eventq-dialog-popover__panel' + (panelClass() ? ' ' + panelClass() : '')"
      [class.eventq-dialog-popover__panel--anchored]="isAnchored()"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="hideHeader() ? null : titleId"
      [attr.aria-label]="hideHeader() ? title() : null"
      [style.position]="panelStyle()['position']"
      [style.top]="panelStyle()['top']"
      [style.left]="panelStyle()['left']"
      [style.right]="panelStyle()['right']"
      [style.width]="panelStyle()['width']"
      [style.height]="panelStyle()['height']"
      [style.max-height]="panelStyle()['maxHeight']"
      [style.transform]="panelStyle()['transform']"
      [style.--eventq-dialog-popover-width]="centerPanelStyle()['width']"
      [style.--eventq-dialog-popover-height]="centerPanelStyle()['height']"
      [style.--eventq-dialog-popover-max-height]="centerPanelStyle()['max-height']"
    >
      @if (!hideHeader()) {
        <header class="eventq-dialog-popover__header">
          <div class="eventq-dialog-popover__title-row">
            @if (titleIcon(); as icon) {
              <mat-icon class="eventq-dialog-popover__title-icon" aria-hidden="true">{{ icon }}</mat-icon>
            }
            <h2 [id]="titleId" class="eventq-dialog-popover__title">{{ title() }}</h2>
          </div>
          <button
            type="button"
            class="eventq-dialog-popover__close"
            aria-label="Close"
            (click)="onClose()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </header>
      }

      <div
        class="eventq-dialog-popover__body"
        [class.eventq-dialog-popover__body--flush]="hideHeader()"
        [class.eventq-dialog-popover__body--no-scroll]="!bodyScroll()"
      >
        <ng-content />
      </div>

      @if (showFooter()) {
        <footer class="eventq-dialog-popover__footer">
          <button type="button" class="eventq-dialog-popover__cancel" (click)="onClose()">
            {{ cancelLabel() }}
          </button>
          @if (showConfirm()) {
            <button
              type="button"
              class="eventq-dialog-popover__confirm"
              [disabled]="confirmDisabled()"
              (click)="onConfirm()"
            >
              {{ confirmLabel() }}
            </button>
          }
        </footer>
      }
    </div>
  </div>
}
